export function ibanFieldValidator(ibanValue : string) {
	return function(callback : (isValid : boolean, error? : JQuery.jqXHR) => void) {
		$.ajax({
			dataType: 'json',
			error(err) {
				if (err.status === 404 && err.responseJSON && err.responseJSON.code === 'INVALID_REQUEST_RESOURCE') {
					callback(false);
				} else {
					callback(false, err);
				}
			},
			success(data) {
				callback(Boolean(data && Array.isArray(data) && data.length));
			},
			type: 'GET',
			url: `/portal-services/oce-iban/${ibanValue}`,
		});
	};
}

export function urlBlacklistValidation(url : string, inverse : boolean) {
	return function(callback : (isValid : boolean, error? : JQuery.jqXHR) => void) {
		$.ajax({
			data: {
				isInsideForm: true,
				language: document.documentElement.lang || 'de',
				path: window.location.pathname,
				url,
			},
			error: () => callback(inverse),
			success: () => callback(!inverse),
			type: 'POST',
			url: '/etc/swisscom/servlets/public/urlchecker.urlchecker.json',
		});
	};
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/formValidators.ts